export default "__VITE_ASSET__MPr45x2D__"